import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38feb5ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "loader",
  style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 120 120",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "circl__rotate"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "load one",
    cx: "60",
    cy: "60",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    class: "load two",
    cx: "60",
    cy: "60",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    class: "load three",
    cx: "60",
    cy: "60",
    r: "40"
  })
], -1))
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "119.221",
  height: "125.613",
  viewBox: "0 0 119.221 125.613",
  style: {"position":"relative","top":"-135px"},
  class: "logo__circle"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<g id=\"Litlle_Loading_Animation\" data-name=\"Litlle Loading Animation\" transform=\"translate(-346.32 -196.068)\" data-v-38feb5ae><g id=\"iknowa_logo\" data-name=\"iknowa logo\" transform=\"translate(-26.879 -212.879)\" data-v-38feb5ae><circle id=\"BG\" cx=\"27\" cy=\"27\" r=\"26\" transform=\"translate(405.879 447.879)\" fill=\"#2a65e8\" data-v-38feb5ae></circle><g id=\"IKNOWA_logo_svg\" data-name=\"IKNOWA logo svg\" transform=\"translate(420.379 459.545)\" data-v-38feb5ae><path id=\"Shape\" d=\"M254.1,407.156a2.611,2.611,0,1,1-.2-1.04A2.61,2.61,0,0,1,254.1,407.156Zm0,24.258h-5.335V412.159h5.3Z\" transform=\"translate(-248.683 -404.446)\" fill=\"#fff\" data-v-38feb5ae></path><path id=\"Path\" d=\"M316.482,465.963h-5.157v-2.372a4.687,4.687,0,0,0-1.27-3.276,3.837,3.837,0,0,0-3.064-1.35h-.625v7h-5.3V446.748h5.3v7.136h.625a3.748,3.748,0,0,0,2.856-1.171,4.767,4.767,0,0,0,1.478-3.008v-2.977h5.167v2.5a9.423,9.423,0,0,1-3.183,7.146,9.453,9.453,0,0,1,3.164,7.216V464.8Z\" transform=\"translate(-291.491 -438.996)\" fill=\"#fff\" data-v-38feb5ae></path><circle id=\"Oval\" cx=\"2.718\" cy=\"2.718\" r=\"2.718\" transform=\"translate(0)\" fill=\"#fff\" data-v-38feb5ae></circle></g></g></g>", 1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}